import styled from 'styled-components';
import Button from '../../../_shared/components/Button';
import Icon from '../../../_shared/components/Icon';

export const StyledWrapper = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.COLORS.BASE};
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 18px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
`;

export const PageButton = styled(Button.Secondary)`
  display: flex;
  align-items: center;
  padding: 6px 42px;
  position: relative;
`;

export const LeftArrow = styled(Icon).attrs({
  icon: 'TR5-Prev_chev'
})`
  position: absolute;
  left: 10px;
  width: 14px;
  height: auto;
`;

export const RightArrow = styled(Icon).attrs({
  icon: 'TR5-Next_chev'
})`
  position: absolute;
  right: 10px;
  width: 14px;
  height: auto;
`;

export const Spaceholder = styled.div`
  width: 127px;
`;
